import React, {Component} from 'react';
// import {
//     ShareButtons
// } from 'react-share';
import {FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon,  WhatsappShareButton, WhatsappIcon, EmailShareButton, EmailIcon, LinkedinShareButton, LinkedinIcon} from 'react-share';
import './style.scss'


class SocialShare extends Component {
    constructor(props) {
        super(props);
        this.state={
            isUpdate: true,
        }
        this.selectorRef = React.createRef(null);
    }

    componentDidMount(){
        window.addEventListener("mousedown", this.handleClickOutside);
    }
    handleClickOutside = (e) => {
        if (this.state.isUpdate && this.selectorRef.current && !this.selectorRef.current.contains(e.target)) {
            this.setState({
                isUpdate: !this.state.isUpdate,
            });
            this.props.addTodo();
        }
    }
    componentWillUnmount() {
        window.removeEventListener("mousedown", this.handleClickOutside);
    }
    render() {
        let {fundName} = this.props;

        if(fundName){
            var url = window.location.href.replace(/\/$/, "");
            url = url.split('/?')[0] + fundName;
        }
        let shareUrl=__CLIENT__ && fundName ? url : __CLIENT__ ?window.location.href:'';
        return (
            <div className={this.state.isUpdate ? "social-shares visible" : "social-shares"} ref={this.selectorRef}>
                <ul>
                    <li>
                        <FacebookShareButton url={shareUrl}>
                            <FacebookIcon size={25} round={true} />
                        </FacebookShareButton>
                    </li>
                    {this.props.noTwitter ? "" :<li className='newXicon'>
                        <TwitterShareButton url={shareUrl}>
                            {/* <TwitterIcon size={25} round={true} /> */}
                            <img src="/images/New/twitter-02.png" alt="twitter" className='Xicon' width={25} height={25} />
                        </TwitterShareButton>
                    </li>}
                    <li>
                        <LinkedinShareButton url={shareUrl} title={"HDFC"}
                                             separator=":: ">
                            <LinkedinIcon size={25} round={true} />
                        </LinkedinShareButton>
                    </li>
                    <li>
                        <WhatsappShareButton url={shareUrl} title={"HDFC"}
                                             separator=":: ">
                            <WhatsappIcon size={25} round={true} />
                        </WhatsappShareButton>
                    </li>
                    <li>
                        <EmailShareButton url={shareUrl}>
                            <EmailIcon size={25} round={true} />
                        </EmailShareButton>
                    </li>

                </ul>
            </div>
        )
    }
}

export default SocialShare;
